<template>
  <div class="chat_list" :class="{ 'disabled-list': isResponding }">
    <div class="chat-content">
      <div class="sidebar_history">
        <div v-for="(item, index) in flatList" :key="item.id" :ref="'item-' + item.id" :data-id="item.id"
          class="chat_list_content_item_info"
          :class="{ 'active-item': isActiveItem(item.id), 'chat_list_content_item_info': type === 'tz', 'chat_list_content_item_info_t': type === 't', 'masked-fourth': index === 3 }"
          @mouseenter="handleMouseEnter(item.id)" @mouseleave="handleMouseLeave">
          <img v-if="type == 't'" class="chat_tpc_img" :src="getServiceIcon(item.service)" alt="">
          <span class="item-text" @click="clickMessage(item.id, index, item.service, item.readonly)">{{ item.name
          }}</span>
          <div>
            <img v-if="item.pin == 1 && !isHoveredItem(item.id)"
              :src="isActiveItem(item.id) ? require('../assets/images/yzd.png') : require('../assets/images/yzd.png')"
              class="edit-icon" alt="">
          </div>

          <!-- 编辑会话按钮 -->
          <el-dropdown v-show="isHoveredItem(item.id)" trigger="click"
            @command="handleDropdownCommand($event, item, null, index)" :hide-on-click="true" :hide-timeout="0"
            placement="bottom-end">
            <div class="edit-trigger">
              <i class="el-icon-more"></i>
            </div>
            <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
              <!-- 置顶 -->
              <el-dropdown-item command="pinned" class="custom-dropdown-item">
                <img v-if="item.pin == 0" src="../assets/images/ddz.png" class="dropdown-icon" alt="">
                <img v-else src="../assets/images/qxzd.png" class="dropdown-icon" alt="">
                <span v-if="item.pin == 0" class="dropdown-text">{{ $t('chatListI18n.Pinned') }}</span>
                <span v-else class="dropdown-text">{{ $t('chatListI18n.qxPinned') }}</span>
              </el-dropdown-item>
              <!-- 重命名 -->
              <el-dropdown-item v-if="!item.readonly" command="rename" class="custom-dropdown-item">
                <img src="../assets/images/edit.png" class="dropdown-icon" alt=""></img>
                <span class="dropdown-text">{{ $t('chatListI18n.rename') }}</span>
              </el-dropdown-item>
              <!-- 删除 -->
              <el-dropdown-item command="delete" class="custom-dropdown-item">
                <img src="../assets/images/delete.png" class="dropdown-icon" alt="">
                <span class="dropdown-text">{{ $t('chatListI18n.delete') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-if="flatList.length === 0" class="empty-state">
          <!-- 加载中 -->
          <div v-if="loading" class="loading-wrapper">
            <div class="loading-spinner"></div>
            <span>{{ $t('Knowledge.sending') }}</span>
          </div>
          <!-- 加载完成，无数据 -->
          <div v-else>{{ $t('chatListI18n.noRecords') }}</div>
        </div>
      </div>
    </div>

    <!-- 重命名会话 -->
    <el-dialog :title="$t('chatListI18n.rename')" :visible.sync="renameDialogVisible" :modal-append-to-body="true"
      :append-to-body="true" :close-on-click-modal="false" custom-class="custom-dialog"
      :before-close="() => (renameDialogVisible = false)" @close="renameInput = ''" center top="30vh">
      <div class="dialog-content">
        <div class="dialog-text">{{ $t('chatListI18n.renamePlaceholder') }}</div>
        <el-input v-model="renameInput" :placeholder="$t('chatListI18n.renamePlaceholder')" maxlength="20"
          class="custom-input" show-word-limit />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="renameDialogVisible = false" class="custom-cancel-btn">
          {{ $t('chatListI18n.cancel') }}
        </el-button>
        <el-button type="primary" @click="handleRename" class="custom-confirm-btn">
          {{ $t('chatListI18n.confirm') }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 删除会话 -->
    <el-dialog :title="$t('chatListI18n.deleteTitle')" :visible.sync="deleteDialogVisible" :modal-append-to-body="true"
      :append-to-body="true" :close-on-click-modal="false" custom-class="custom-delete-dialog"
      :before-close="() => (deleteDialogVisible = false)" center top="30vh">
      <div class="dialog-content">
        <div class="dialog-text">{{ $t('chatListI18n.deleteDesc') }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false" class="custom-cancel-btn">
          {{ $t('chatListI18n.cancel') }}
        </el-button>
        <el-button type="primary" @click="confirmDelete" class="custom-delete-btn">
          {{ $t('chatListI18n.deleteConfirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  conversationsList,
  renameConversation,
  deleteConversation,
  pinnedConversation
} from "@/api";
import { mapState, mapMutations } from "vuex";

export default {
  name: 'ChatList',
  props: {
    type: {
      type: String,
      required: false,
      validator(value) {
        // 可选：限制合法的 type 值
        return ['ai', 't', 'tz'].includes(value);
      }
    },
    sidebarWidth: Boolean
  },
  components: {},
  data() {
    return {
      flatList: [], // 扁平化会话列表
      current: null,
      activeItemId: null,
      hoveredItemId: null,
      renameDialogVisible: false,
      renameInput: "",
      renameTarget: null,
      deleteDialogVisible: false,
      deleteTarget: null,
      loading: false,
    };
  },
  computed: {
    ...mapState(["userInfo", "accessType", "isResponding"]),

  },
  methods: {
    ...mapMutations(['setAccessType','setReadonly']),

    // 通知刷新列表
    loadHistory(serviceType) {
      // console.log(serviceType,'serviceType')
      this.loadList()
    },

    // 初始化列表
    loadList() {
      if (!this.userInfo?.user_id) return Promise.resolve();
      
      // 开始加载
      this.loading = true;

      return conversationsList({
        user: this.userInfo.user_id,
        access_type: this.type == 'tz' ? 'tz' : 'all',
        limit: 100,
      })
      .then((res) => {
        const data = res.data.data.data || [];
        // 按更新时间倒序（最新在前）
        data.sort((a, b) => (b.updated_at || 0) - (a.updated_at || 0));
        this.flatList = data;
        
        this.$nextTick(() => {
          this.scrollToActiveItem();
        });
        
        if (this.flatList.length === 0) {
          this.$emit('empty');
        } else {
          this.$emit('not-empty');
        }
      })
      .catch((error) => {
        console.log(error)
        this.$emit("close-chat-list");
        this.$message.error(this.$t('chatListI18n.loadListError'));
        this.$emit('empty');
        return Promise.reject(error);
      })
      .finally(() => {
        // 无论成功失败，关闭加载
        this.loading = false;
      });
    },

    // 外部（我的方案）跳转指定会话时：刷新列表、锁定高亮并滚动到该项
    focusConversationById(conversationId) {
      if (conversationId == null || conversationId === '') return Promise.resolve();
      const id = String(conversationId);
      this.activeItemId = id;
      return this.loadList().then(() => {
        const idx = this.flatList.findIndex((item) => String(item.id) === id);
        this.current = idx >= 0 ? idx : null;
        this.$nextTick(() => {
          this.scrollToActiveItem();
        });
      });
    },

    // 获取不同图片路径
    getServiceIcon(service) {
      // 根据 service 值返回对应的图片路径
      const iconMap = {
        'tpc': require('../assets/images/chat_tpc.png'),
        'tzj': require('../assets/images/chat_tzj.png'),
      };
      return iconMap[service] || require('../assets/images/chat_tpc.png');
    },

    // 点击列表数据
    clickMessage(id, index, value, readonly) {
      this.$root.$emit('close-carbon-path'); // 关闭碳行
      this.setAccessType(value);
      const boolReadonly = readonly === true || readonly === 'true';
      this.setReadonly(boolReadonly);
      if (this.$route.name !== "ChatPage" || this.$route.query.id !== id) {
        this.$router
          .push({
            name: "ChatPage",
            query: { id: id,},
          })
          .catch((err) => {
            this.$emit("close-chat-list");
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.current = index;
      this.activeItemId = id;
    },

    // 打开重命名
    openRenameDialog(item, date, index, i) {
      this.renameTarget = { item, date, index, i };
      this.renameInput = item.name;
      this.renameDialogVisible = true;
    },

    // 重命名确定按钮
    async handleRename() {
      const { item } = this.renameTarget || {};
      const newName = this.renameInput.trim();
      if (!newName) {
        this.$message.error(this.$t('chatListI18n.nameEmpty'));
        return;
      }
      if (newName === item.name) {
        this.renameDialogVisible = false;
        this.renameInput = "";
        return;
      }

      const data = {
        access_type: this.renameTarget.item.service,
        rename: newName,
      };
      renameConversation(item.id, data)
        .then((res) => {
          if(res.data.code == 200){
            console.log(item,'item')
            this.$message.success(this.$t('chatListI18n.renameSuccess'));
            this.renameDialogVisible = false;
            this.renameInput = "";
            if (item.first == 1) {
              this.handlerPinned(item)
            }
            this.loadList();
          } else {
            this.$message.error(res.data.data);
          }
        })
        .catch((err) => {
          this.$message.error(this.$t('chatListI18n.renameFail'));
        });
    },

    // DropdownCommand选项  first
    handleDropdownCommand(command, item, date, index) {
      
      if (command === "rename") {
        item.first = 0
        this.openRenameDialog(item, date, index);
      } else if (command === "delete") {
        this.deleteMessage(item);
      } else {
        // item.first = 1  // 放开实现置顶时重命名
        // this.openRenameDialog(item, date, index)  // 放开实现置顶时重命名
        this.handlerPinned(item)
      }
    },

    // 置顶功能
    handlerPinned(item) {
      if (item.pin == 0) {
        const data = {
          access_type: item.service,
          pin: 1
        }
        pinnedConversation(item.id, data)
          .then(() => {
            this.$message.success(this.$t('chatListI18n.pinnedSuccess'));
            this.loadList();
          })
          .catch((err) => {
            this.$message.error(this.$t('chatListI18n.pinnedFail'));
          });
      } else {
        const data = {
          access_type: item.service,
          pin: 0
        }
        pinnedConversation(item.id, data)
          .then(() => {
            this.$message.success(this.$t('chatListI18n.CancelPinnedSuccess'));
            this.loadList();
          })
          .catch((err) => {
            this.$message.error(this.$t('chatListI18n.CancelPinnedFail'));
          });
      }

    },

    // 删除功能
    deleteMessage(item) {
      this.deleteTarget = item;
      this.deleteDialogVisible = true;
    },

    // 确定删除
    confirmDelete() {
      if (!this.deleteTarget) return;

      const data = {
        data: {
          access_type: this.deleteTarget.service,
        },
      };
      deleteConversation(this.deleteTarget.id, data)
        .then(() => {
          const urlParams = new URLSearchParams(window.location.search);
          if (this.deleteTarget.id == urlParams.get("id")) {
            this.$emit("start-new-chat");
          }
          this.$message.success(this.$t('chatListI18n.deleteSuccess'));
          this.deleteDialogVisible = false;
          this.deleteTarget = null;
          this.loadList();
        })
        .catch((err) => {
          this.$message.error(this.$t('chatListI18n.deleteFail'));
        });
    },

    // 选中项函数
    isActiveItem(itemId) {
      const urlParams = new URLSearchParams(window.location.search);
      return this.activeItemId === itemId || urlParams.get("id") == itemId;
    },

    isHoveredItem(itemId) {
      return this.hoveredItemId === itemId;
    },

    // 鼠标悬停效果
    handleMouseEnter(itemId) {
      this.hoveredItemId = itemId;
    },

    // 鼠标移走效果
    handleMouseLeave() {
      this.hoveredItemId = null;
    },

    // 滚动到选中列表位置
    scrollToActiveItem() {
      if (!this.activeItemId) return;

      this.$nextTick(() => {
        const refName = 'item-' + this.activeItemId; // 👈 正确拼接
        const refs = this.$refs[refName];
        if (refs && refs[0]) {
          refs[0].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    }
  },

  watch: {
    '$route'(to, from) {
      // 当路由变化时，检查 query.id 是否存在
      const newId = to.query.id;
      if (newId !== undefined && newId !== null) {
        this.activeItemId = String(newId);
        if (this.flatList.length > 0) {
          this.scrollToActiveItem();
        }
      } else {
        // 清除激活项
        this.activeItemId = null;
      }
    }
  },

  mounted() {
    this.loadList();
    if (this.$route.query.id) {
      this.activeItemId = this.$route.query.id || null; // 显式初始化
    }
  },
};
</script>

<style scoped>
.disabled-list {
  pointer-events: none;
}

.chat-content::-webkit-scrollbar {
  display: none !important;
}

.chat_list_content {
  height: 100%;
  overflow-y: auto;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.chat_tpc_img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.chat_list_content::-webkit-scrollbar {
  display: none !important;
}

.sidebar_history {
  /* height: 780px; */
  /* max-height: 680px; */
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

}

.item-text {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  color: rgba(90, 102, 114, 1);
  font-size: 14px;
  font-weight: 400;
  text-overflow: ellipsis;
  width: calc(100% - 30px);
}

.chat_list_content_item_info {
  display: flex;
  align-items: center;
  padding-left: 4px;
  padding-right: 10px;
  color: rgba(68, 77, 85, 1);
  font-size: 14px;
  line-height: 40px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  border-radius: 6px;
  margin-bottom: 4px;
}

.el-dropdown {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.chat_list_content_item_info:hover {
  background-color: rgba(209, 219, 242, 1);
  border-radius: 10px;
  transition: all 0.2s ease;
}

.chat_list_content_item_info:hover .item-text {
  color: rgba(68, 77, 85, 1);
  padding-right: 20px;
}

.chat_list_content_item_info_t:hover .item-text {
  color: rgba(68, 77, 85, 1);
  padding-right: 20px;
}

.chat_list_content_item_info_t:hover {
  background-color: rgba(209, 219, 242, 1);
  border-radius: 10px;
  padding-right: 6px;
}

.chat_list_content_item_info.active-item {
  background-color: rgba(209, 219, 242, 1);
  border-radius: 10px;
  padding-right: 10px;
}

.chat_list_content_item_info.active-item .item-text {
  color: rgba(68, 77, 85, 1);
  padding-right: 20px;
}

.chat_list_content_item_info span {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: middle;
}

.edit-icon {
  width: 22px;
  height: 22px;
  cursor: pointer;
  vertical-align: middle;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.edit-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  transition: all 0.3s ease;
  padding-right: 18px;
}

.el-icon-more {
  color: rgba(90, 102, 114, 1);
  font-size: 14px;
}

.empty-state {
  text-align: center;
  color: #aaa;
  font-size: 14px;
  padding: 40px 0;
}

.icon {
  width: 12px;
  height: 44px;
}
</style>

<style>
/* Tooltip 样式 */
.el-tooltip__popper.is-dark {
  background-color: rgba(117, 117, 117, 1) !important;
  color: #fff;
}

.el-tooltip__popper.is-dark[x-placement^="top"] .popper__arrow::after,
.el-tooltip__popper.is-dark[x-placement^="top"] .popper__arrow {
  border-top-color: transparent !important;
}

/* 重命名对话框 */
.custom-dialog {
  border-radius: 12px !important;
  overflow: visible !important;
}

.custom-dialog .el-dialog__header {
  /* background: linear-gradient(135deg, #56c697 0%, #339e9e 100%) !important; */
  background: var(--global-background);
  color: white !important;
  padding: 20px 24px 16px 24px !important;
  margin: 0 !important;
  border-bottom: none !important;
}

.custom-dialog .el-dialog__title {
  color: white !important;
  font-size: 18px !important;
  font-weight: 600 !important;
}

.custom-dialog .el-dialog__headerbtn {
  top: 16px !important;
  right: 20px !important;
}

.custom-dialog .el-dialog__close {
  color: white !important;
  font-size: 20px !important;
}

.custom-dialog .el-dialog__close:hover {
  color: rgba(255, 255, 255, 0.8) !important;
}

.custom-dialog .el-dialog__body {
  padding: 24px !important;
  background: #fff !important;
}

.custom-dialog .el-dialog__footer {
  padding: 16px 24px 24px 24px !important;
  background: #fff !important;
  text-align: center !important;
}

.dialog-content {
  text-align: center;
}

.dialog-text {
  color: #606266;
  font-size: 16px;
  margin-bottom: 20px;
  line-height: 1.5;
}

.custom-input .el-input__inner {
  border-radius: 8px !important;
  border: 0.4px solid #e4e7ed !important;
  padding: 12px 16px !important;
  font-size: 16px !important;
  transition: all 0.3s ease !important;
}

.custom-input .el-input__inner:focus {
  border-color: var(--global-primary) !important;
  box-shadow: 0 0 0 2px rgba(86, 198, 151, 0.2) !important;
}

.custom-input .el-input__count {
  color: #909399 !important;
  font-size: 12px !important;
}

.custom-cancel-btn {
  background: #f5f7fa !important;
  border: 0.2px solid #dcdfe6 !important;
  color: #606266 !important;
  padding: 12px 24px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  margin-right: 16px !important;
  min-width: 80px !important;
  transition: all 0.3s ease !important;
}

.custom-cancel-btn:hover {
  background: #e6e8eb !important;
  border-color: #c0c4cc !important;
  color: #606266 !important;
}

.custom-confirm-btn {
  /* background: linear-gradient(135deg, #56c697 0%, #339e9e 100%) !important; */
  background: var(--global-primary);
  border: none !important;
  color: white !important;
  padding: 12px 24px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  min-width: 80px !important;
  box-shadow: 0 2px 8px rgba(86, 198, 151, 0.3) !important;
  transition: all 0.3s ease !important;
}

.custom-confirm-btn:hover {
  background: var(--global-primary) !important;
  box-shadow: 0 4px 12px rgba(86, 198, 151, 0.4) !important;
}

/* 删除对话框 */
.custom-delete-dialog {
  border-radius: 12px !important;
  overflow: hidden !important;
}

.custom-delete-dialog .el-dialog__header {
  background: var(--global-background) !important;
  color: white !important;
  padding: 20px 24px 16px 24px !important;
  margin: 0 !important;
  border-bottom: none !important;
}

.custom-delete-dialog .el-dialog__title {
  color: white !important;
  font-size: 18px !important;
  font-weight: 600 !important;
}

.custom-delete-dialog .el-dialog__headerbtn {
  top: 16px !important;
  right: 20px !important;
}

.custom-delete-dialog .el-dialog__close {
  color: white !important;
  font-size: 20px !important;
}

.custom-delete-dialog .el-dialog__close:hover {
  color: rgba(255, 255, 255, 0.8) !important;
}

.custom-delete-dialog .el-dialog__body {
  padding: 24px !important;
  background: #fff !important;
}

.custom-delete-dialog .el-dialog__footer {
  padding: 16px 24px 24px 24px !important;
  background: #fff !important;
  text-align: center !important;
}

.custom-delete-btn {
  background: var(--global-background) !important;
  border: none !important;
  color: white !important;
  padding: 12px 24px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  min-width: 80px !important;
  box-shadow: 0 2px 8px rgba(86, 198, 151, 0.3) !important;
  transition: all 0.3s ease !important;
}

.custom-delete-btn:hover {
  background: var(--global-primary) !important;
  box-shadow: 0 4px 12px rgba(86, 198, 151, 0.4) !important;
}

/* 下拉菜单样式 */
.custom-dropdown-menu {
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  padding: 8px !important;
  min-width: 140px !important;
  background: white !important;
  overflow: hidden !important;
}

.custom-dropdown-item {
  padding: 12px 20px !important;
  color: rgba(68, 77, 85, 1) !important;
  border-radius: 12px !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  transition: all 0.3s ease !important;
  border-bottom: none !important;
  display: flex !important;
  align-items: center !important;
  margin: 0 !important;
}

.custom-dropdown-item:hover {
  background: #f0f0f0 !important;
}

.dropdown-icon {
  margin-right: 10px !important;
  width: 16px !important;
  text-align: center !important;
}

.dropdown-text {
  font-weight: 500 !important;
}

/* 加载中动画 */
.empty-state .loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #999;
  font-size: 14px;
}
.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #e5e5e5;
  border-top-color: #1677ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>